<template>
  <div class="nk-info">
    <a class="icon"><i :class="iconComputed"></i></a>
    <span class="info">{{ text }}</span>
  </div>
</template>

<script>
  export default {
    props: {
      text: {
        type: String,
        required: true
      },
      icon: {
        type: String,
        requried: true
      },
      iconType: {
        type: String,
        default: 'fas fa'
      }
    },
    computed: {
      iconComputed() {
        return this.iconType + '-' + this.icon
      }
    }
  }
</script>

<style lang="less">
  @import "~/styles/nikan-info.less";
</style>